"use strict";

exports.__esModule = true;
exports.ModeSwitch = ModeSwitch;
var _react = _interopRequireDefault(require("react"));
var _Env = require("../../Env");
var _constants = require("../../Auth/constants");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * Renders the `monoserver` prop in monoserver mode and `enrich` prop in enrich mode.
 */
function ModeSwitch(_ref) {
  var enrich = _ref.enrich,
    monoserver = _ref.monoserver;
  var _React$useContext = _react["default"].useContext(_Env.EnvContext),
    licence = _React$useContext.licence;
  var isEnrichMode = licence.accessRights.includes(_constants.ACCESS_RIGHT_ENRICH);
  return isEnrichMode ? enrich : monoserver;
}